export const actions = "awcfsxx";
export const logoContainer = "ll92swq";
export const logo = "l1iqk7g7";
export const rightBorder = "rw1ciln";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");